<div [ngClass]="tabs?.class && tabs.class">
  <ul class="tabs" data-cy="tabs">
    <li
      *ngFor="let tab of tabsItems"
      (click)="click(tab, $event)"
      [ngClass]="{ active: isActive(tab), disable: isDisable(tab) }"
      class="item {{ tab?.class && tab.class }}"
      [attr.data-intercom-target]="tab?.dataIntercomTarget"
      [routerLinkActive]="hasRouting ? 'active-route' : ''">
      <ng-container *ngIf="hasRouting; else withoutRouting">
        <a [routerLink]="getLink(tab)" [queryParams]="getQueryParams(tab)" class="link">
          <span *ngIf="tab.icon" [ngClass]="tab.icon ? tab.icon : ''" class="icon"> </span>

          <span class="decs d-flex">
            <span class="title" *ngIf="tab.title">
              {{ tab.title | translate }}
            </span>
          </span>

          <span *ngIf="tab.desc" class="tab-desc">{{ tab.desc }}</span>

          <span *ngIf="tab.counter && tab.showCounter">
            <span *ngIf="tab.counter[tab.counterIdentifier]" class="count">
              <span [innerText]="tab.counter[tab.counterIdentifier] > 100 ? '100+' : tab.counter[tab.counterIdentifier]"></span>
            </span>
          </span>
        </a>
      </ng-container>

      <ng-template #withoutRouting>
        <span class="link">
          <span *ngIf="tab.icon" [ngClass]="tab.icon ? tab.icon : ''" class="icon"> </span>

          <span class="decs d-flex">
            <span class="title" *ngIf="tab.title">
              {{ tab.title | translate }}
            </span>
          </span>

          <span *ngIf="tab.desc" class="tab-desc">{{ tab.desc }}</span>

          <span *ngIf="tab.counter && tab.showCounter">
            <span *ngIf="tab.counter[tab.counterIdentifier]" class="count">
              <span [innerText]="tab.counter[tab.counterIdentifier] > 100 ? '100+' : tab.counter[tab.counterIdentifier]"></span>
            </span>
          </span>
        </span>
      </ng-template>
    </li>
  </ul>
</div>
